import Vue from 'vue'
import VueRouter from 'vue-router'
import PageName from '../constant/PageName'
import {getLoginToken} from '../cache/Cache'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect:'/apply',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/login'),
    meta: {
      title: "登录",
    },
  },
  {
    path: '/apply',
    name: 'apply',
    component: () => import('@/pages/apply'),
    meta: {
      title: "项目申报",
    },
  },
  {
    path: '/apply-list',
    name: 'apply-list',
    component: () => import('@/pages/apply/list'),
    meta: {
      title: "申请列表",
    },
  },
  {
    path: '/apply-detail',
    name: 'apply-detail',
    component: () => import('@/pages/apply'),
    meta: {
      type:'detail',
      title: "项目申报详情",
    },
  },

]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let title = to.meta.title;
  title = title || '';
  window.document.title = title;

  let hasToken = getLoginToken()
  if (hasToken && to.path === '/login') {
    next({ path: '/apply-list' })
    return
  }
  if(!hasToken && to.path !== '/login' && to.path !== '/home'){
    next({ path: '/login' })
    return
  }
  next();
});



router.afterEach((to) => {
  window.scrollTo(0, 0);
});

export default router
